import React from 'react';

import { faList } from '@fortawesome/sharp-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { FormStructure } from '@europrocurement/flexy-form';
import HeaderStructure from '../../../../fragments/HeaderStructure';
import productsArrayStructure from './productsArrayStructure';

import type { ProductsStructureProps } from '../../types';

export default ({
    formContext,
    rubFacts,
    txTva,
    mode,
    headerSwitches = [],
    headerChildren = [],
    hasBlured,
    openModal,
    handleTotalsLock,
    stateSwitchLockValues,
}: ProductsStructureProps): Array<FormStructure> => [
    {
        type: 'header',
        name: 'products_header',
        label: (
            <HeaderStructure
                icon={<FontAwesomeIcon icon={faList} />}
                title="Rubriques"
                controls={headerChildren}
                switches={headerSwitches}
            />
        ),
    },
    ...productsArrayStructure({
        formContext,
        rubFacts,
        txTva,
        mode,
        hasBlured,
        openModal,
        handleTotalsLock,
        stateSwitchLockValues,
    }),
];
